const getAllTopLevelPlatformsQuery = /* GraphQL */ `
  query AllTopLevelPlatforms {
    links: allTopLevelPlatforms {
      href: url
      primary: fullName
      subItems: childPlatforms {
        href: url
        primary: partialName
      }
    }
  }
`

export default getAllTopLevelPlatformsQuery
